module.exports = {
      id: "comments-outline-usage",
      viewBox: "0 0 32 36",
      url: "/" + "sprite-830c6fc89c6e575b53718d760c90aee8.svg#comments-outline",
      toString: function () {
        return this.url;
      }
    }